<template>
    <div v-if="loaded">

        <v-row no-gutters class="pl-9 pr-8 pt-8 mb-2">
            <v-col>
                <div class="title mb-3">{{ $t('Incoming emails') }}</div>
                <div class="mt-2 ml-2">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.ALLOW_EMAIL_TO_TASK, $event)" :label="$t('Allow email to task') + ':'" :value="settings[MAILBOX_SETTINGS.ALLOW_EMAIL_TO_TASK]===1"/>
                    <div class="pl-11 body-2" v-html='$t("Forward emails to <b>uku@getuku.email</b> to automatically create tasks from the email content.")'/>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters class="pl-9 pr-8 mb-2">
            <v-col>
                <div class="ml-2">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.ALLOW_CLIENT_REPLY, $event)" :label="$t('Allow client replies') + ':'" :value="settings[MAILBOX_SETTINGS.ALLOW_CLIENT_REPLY]===1"/>
                    <div class="pl-11 body-2" v-html='$t("When you email a client from their profile, their reply is added to Client Communication in Uku, and you receive a new task with their response.")'/>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters class="pl-9 pr-8 mb-2">
            <v-col>
                <div class="ml-2">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.ALLOW_PROJECT_REPLY, $event)" :label="$t('Allow project replies') + ':'" :value="settings[MAILBOX_SETTINGS.ALLOW_PROJECT_REPLY]===1"/>
                    <div class="pl-11 body-2" v-html='$t("When you email a client from a project, their reply is added to Project Communication in Uku, and a new task is created with their response.")'/>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters class="pl-9 pr-8 mb-2">
            <v-col>
                <div class="ml-2">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.ALLOW_TASK_REPLY, $event)" :label="$t('Allow task reply') + ':'" :value="settings[MAILBOX_SETTINGS.ALLOW_TASK_REPLY]===1"/>
                    <div class="pl-11 body-2" v-html='$t("Client replies to emails sent from a task are added to that same task in Uku.") '/>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters class="pl-9 pr-8 mb-2">
            <v-col>
                <div class="ml-2 mb-4">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.SEND_BLIND_COPY, $event)" :label="$t('Email copy') + ':'" :value="settings[MAILBOX_SETTINGS.SEND_BLIND_COPY]===1"/>
                    <div class="pl-11 body-2" v-html='$t("Receive a copy via email whenever a client replies to an email sent from Uku.")'/>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters class="pl-9 pr-8 mb-2">
            <v-col>
                <div class="title mb-3">{{ $t('Limitations') }}</div>
                <div class="ml-2 mt-2 mb-2">
                    <switch-button @change="saveSetting(MAILBOX_SETTINGS.ALLOW_ONLY_CONTACTS, $event)" :label="$t('Allow only contacts') + ':'" :value="settings[MAILBOX_SETTINGS.ALLOW_ONLY_CONTACTS]===1"/>
                    <div class="pl-11 body-2" v-html='$t("Uku accepts replies only from contacts added under the client, preventing spam and maintaining quality.")'/>
                </div>
            </v-col>
        </v-row>

    </div>
</template>

<script>
import {$t} from "@/i18n";
import {ref} from "@vue/composition-api";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import {APP_STORE_APP_IDS, MAILBOX_SETTINGS} from "@/helpers/constants"
import FeatureModule from "@/store/modules/feature";
import AppStoreListHeader from "../../../../components/AppStore/AppStoreListHeader.vue";


export default {
    name: "EmailingSettingsTab",
    components: {AppStoreListHeader},
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const {getAppSettings, saveAppSettings} = FeatureModule();
        const loaded = ref(false)
        const settings = ref()
        const company = ref()
        const {appStoreDialogGetters} = appStoreDialog()


        const onLoaded = async function () {
            company.value = appStoreDialogGetters.getSelectedCompany()
            settings.value = await getAppSettings({
                company_id: company.value.id,
                feature_id: APP_STORE_APP_IDS.MAILBOX
            }) || {}

            settings.value[MAILBOX_SETTINGS.ALLOW_ONLY_CONTACTS] = settings.value[MAILBOX_SETTINGS.ALLOW_ONLY_CONTACTS] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.ALLOW_ONLY_ASSIGNEES] = settings.value[MAILBOX_SETTINGS.ALLOW_ONLY_ASSIGNEES] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.ALLOW_TASK_REPLY] = settings.value[MAILBOX_SETTINGS.ALLOW_TASK_REPLY] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.ALLOW_PROJECT_REPLY] = settings.value[MAILBOX_SETTINGS.ALLOW_PROJECT_REPLY] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.ALLOW_CLIENT_REPLY] = settings.value[MAILBOX_SETTINGS.ALLOW_CLIENT_REPLY] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.ALLOW_EMAIL_TO_TASK] = settings.value[MAILBOX_SETTINGS.ALLOW_EMAIL_TO_TASK] ? 1 : 0
            settings.value[MAILBOX_SETTINGS.SEND_BLIND_COPY] = settings.value[MAILBOX_SETTINGS.SEND_BLIND_COPY] ? 1 : 0

            loaded.value = true
        }
        onLoaded()

        const getLabel = (key) => {
            return $t(key)
        }
        const saveSetting = async (key, value) => {
            settings.value[key] = value ? 1 : 0
            const updated_settings = await saveAppSettings({
                company_id: company.value.id,
                feature_id: APP_STORE_APP_IDS.MAILBOX,
                data: settings.value
            })
        }
        return {
            MAILBOX_SETTINGS,
            loaded,
            settings,
            saveSetting,
            getLabel,
        };
    }
};
</script>
